const SEAT_BOOKING_GET_DATA = {
  SEAT_BOOKING_GET_DATA_LOAD: "SEAT_BOOKING_GET_DATA_LOAD",
  SEAT_BOOKING_GET_DATA_SUCCESS: "SEAT_BOOKING_GET_DATA_SUCCESS",
  SEAT_BOOKING_GET_DATA_FAIL: "SEAT_BOOKING_GET_DATA_FAIL",
};

const SEAT_BOOKING_GET_API = "/seatreservation";

const SEAT_BOOKING_DATA = {
  SEAT_BOOKING_DATA_LOAD: "SEAT_BOOKING_DATA_LOAD",
  SEAT_BOOKING_DATA_SUCCESS: "SEAT_BOOKING_DATA_SUCCESS",
  SEAT_BOOKING_DATA_FAIL: "SEAT_BOOKING_DATA_FAIL",
};

const SEAT_BOOKING_API = "/seatreservation/floorplans";

/* ================= ADD SEAT BOOKING ================= */

const SEAT_BOOKING_ADD_DATA = {
  SEAT_BOOKING_ADD_DATA_LOAD: "SEAT_BOOKING_ADD_DATA_LOAD",
  SEAT_BOOKING_ADD_DATA_SUCCESS: "SEAT_BOOKING_ADD_DATA_SUCCESS",
  SEAT_BOOKING_ADD_DATA_FAIL: "SEAT_BOOKING_ADD_DATA_FAIL",
};

const SEAT_BOOKING_ADD_API = "/seatreservation";

/* ================= CANCEL SEAT BOOKING ================= */

const SEAT_BOOKING_CANCEL_DATA = {
  SEAT_BOOKING_CANCEL_DATA_LOAD: "SEAT_BOOKING_CANCEL_DATA_LOAD",
  SEAT_BOOKING_CANCEL_DATA_SUCCESS: "SEAT_BOOKING_CANCEL_DATA_SUCCESS",
  SEAT_BOOKING_CANCEL_DATA_FAIL: "SEAT_BOOKING_CANCEL_DATA_FAIL",
};

const SEAT_BOOKING_CANCEL_API = "/seatreservation";

/* ================= MY BOOKING ================= */

const MY_BOOKING_GET_DATA = {
  MY_BOOKING_GET_DATA_LOAD: "MY_BOOKING_GET_DATA_LOAD",
  MY_BOOKING_GET_DATA_SUCCESS: "MY_BOOKING_GET_DATA_SUCCESS",
  MY_BOOKING_GET_DATA_FAIL: "MY_BOOKING_GET_DATA_FAIL",
};

const MY_BOOKING_GET_API = "/seatreservation/mybookings";

/* ================= Time SLot ================= */

const SEAT_BOOKING_TIMESLOT_DATA = {
  SEAT_BOOKING_TIMESLOT_DATA_LOAD: "SEAT_BOOKING_TIMESLOT_DATA_LOAD",
  SEAT_BOOKING_TIMESLOT_DATA_SUCCESS: "SEAT_BOOKING_TIMESLOT_DATA_SUCCESS",
  SEAT_BOOKING_TIMESLOT_DATA_FAIL: "SEAT_BOOKING_TIMESLOT_DATA_FAIL",
};

const SEAT_BOOKING_TIMESLOT_API = "/seatreservation/timeslots";



export {
  SEAT_BOOKING_GET_DATA,
  SEAT_BOOKING_GET_API,
  SEAT_BOOKING_DATA,
  SEAT_BOOKING_API,
  SEAT_BOOKING_ADD_DATA,
  SEAT_BOOKING_ADD_API,
  SEAT_BOOKING_CANCEL_DATA,
  SEAT_BOOKING_CANCEL_API,
  MY_BOOKING_GET_DATA,
  MY_BOOKING_GET_API,
  SEAT_BOOKING_TIMESLOT_DATA,
  SEAT_BOOKING_TIMESLOT_API,
};
